// extracted by mini-css-extract-plugin
export default {"overlay":"ImageWithLoader-module__overlay--HWREi"};